import { get } from 'lodash-es';
import { ADD_PRODUCT, REMOVE_PRODUCT, EMPTY_CART, INITIALIZE_CART } from '../actions/cart.actions';

const savedCart = JSON.parse(localStorage.getItem('cart'));

const initialState = {
  order: get(savedCart, 'order', [])
};

export default function cartReducer(state = initialState, action) {
  let indexOf = -1;
  switch (action.type) {
    case ADD_PRODUCT:
      indexOf = state.order.findIndex(p => p.id === action.payload.id);
      if (indexOf === -1) {
        state.order.push(action.payload);
        localStorage.setItem('cart', JSON.stringify(state));
      }
      return {
        ...state,
        order: [...state.order]
      };
    case REMOVE_PRODUCT:
      indexOf = state.order.findIndex(p => p.id === action.payload);
      if (indexOf !== -1) {
        state.order.splice(indexOf, 1);
        localStorage.setItem('cart', JSON.stringify(state));
      }
      return {
        ...state,
        order: [...state.order]
      };
    case EMPTY_CART:
      state.order = [];
      localStorage.setItem('cart', JSON.stringify(state));
      return {
        ...state,
        order: []
      };
    case INITIALIZE_CART:
      state.order = action.payload;
      localStorage.setItem('cart', JSON.stringify(state));
      return {
        ...state,
        order: action.payload
      };
    default:
      return state;
  }
}